import { render, staticRenderFns } from "./VulnAttachmentList.vue?vue&type=template&id=0d75b268&scoped=true"
import script from "./VulnAttachmentList.vue?vue&type=script&lang=js"
export * from "./VulnAttachmentList.vue?vue&type=script&lang=js"
import style0 from "./VulnAttachmentList.vue?vue&type=style&index=0&id=0d75b268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d75b268",
  null
  
)

export default component.exports